<template>
  <div class="header" :style="style" :class="{ color: color }">
    <div class="w">
      <!-- 导航 -->
      <div class="nav_box">
        <div
          class="nav_item"
          v-for="(item, index) in navList"
          :key="index"
          :class="{ activeHearder: activeHearder == index }"
          @click="changeNav(index)"
        >
          {{ item }}
        </div>
      </div>
      <!-- 搜索框 -->
      <div class="search_box">
        <input type="text" placeholder="公共服务平台" />
        <div>
          <i class="el-icon-search"></i>
        </div>
      </div>
      <!-- 个人中心 -->
      <div
        :class="{ activeHearder: down }"
        @mouseenter="perBodyShow"
        @mouseleave="perBodyHide"
        class="personal_box"
      >
        <div class="per_top" @click="goPersonal">
          <img src="../../assets/img/home/img3.png" alt="" />
          个人中心
          <i class="el-icon-caret-bottom el-icon--right"></i>
        </div>
        <div class="per_body" :class="{ per_body2: down2 }">
          <div class="per_body_item">
            <i class="el-icon-user"></i>
            账号管理
          </div>
          <div class="per_body_item">
            <i class=" el-icon-bell"></i>
            消息中心
          </div>
          <div class="goOut">
            退出
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import store from "store";
export default {
  data() {
    return {
      activeHearder: 0,
      down: false,
      down2: false,
      navList: ["首页", "课程中心", "直播公开课", "校园论坛", "公共服务平台"],
      style: {
        backgroundColor: "",
      },
      color: false,
    };
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
    console.log(store.get("active"));
  },
  methods: {
    changeNav(i) {
      store.set("active", i);
      this.activeHearder = i;
      if (i == 0) {
        if (this.$route.path !== "/index") {
          this.$router.push("/index");
        }
      } else if (i == 1) {
        if (this.$route.path !== "/study") {
          this.$router.push("/study");
        }
      } else if (i == 2) {
        if (this.$route.path !== "/live") {
          this.$router.push("/live");
        }
      } else if (i == 3) {
        if (this.$route.path !== "/talk") {
          this.$router.push("/talk");
        }
      } else {
        if (this.$route.path !== "/serve") {
          this.$router.push("/serve");
        }
      }
    },
    // 个人中心
    goPersonal() {
      if (this.$route.path == "/personal") {
        return;
      } else {
        this.$router.push("/personal");
      }
    },
    handleScroll() {
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      // let offsetTop = document.querySelector(".header").offsetTop;
      //设置背景颜色的透明读
      if (scrollTop) {
        // this.style.backgroundColor = `rgba(2,154,255,${scrollTop / scrollTop})`;
        this.color = true;
      } else if (scrollTop == 0) {
        // this.style.backgroundColor = "transparent";
        this.color = false;
      }
    },
    perBodyShow() {
      this.down = true;
      this.down2 = true;
    },
    perBodyHide() {
      this.down = false;
      this.down2 = false;
    },
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
};
</script>
<style lang="less" scoped>
.activeHearder {
  background: rgba(255, 255, 255, 0.11);
  // opacity: 0.11;
  border-bottom: 2px solid #ffffff;
  margin-bottom: 1px;
}
@deep: ~">>>";
input::-webkit-input-placeholder {
  color: #343434;
  font-size: 16px;
}
@deep: ~">>>";
input::-moz-input-placeholder {
  color: #343434;
  font-size: 16px;
}
@deep: ~">>>";
input::-ms-input-placeholder {
  color: #343434;
  font-size: 16px;
}
.header {
  position: fixed;
  top: 100px;
  left: 0;
  z-index: 666;
  width: 100%;
  height: 60px;
  text-align: center;
  // line-height: 60px;
  color: #333;
  background-color: #029aff;
  transition: all linear 0.5s;
  .w {
    display: flex;
    align-items: center;
    width: 1200px;
    margin: 0 auto;
    height: 60px;
    .nav_box {
      display: flex;
      align-items: center;
      height: 60px;
      font-size: 16px;
      color: #fff;
      .nav_item {
        height: 100%;
        line-height: 60px;
        padding: 0 30px;
        box-sizing: border-box;
        cursor: pointer;
      }
    }
    .search_box {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 1px;
      box-sizing: border-box;
      width: 270px;
      height: 40px;
      background: #ffffff;
      border-radius: 5px;
      overflow: hidden;
      margin-left: 30px;
      input {
        border: none;
        height: 100%;
        padding: 0 10px;
        box-sizing: border-box;
      }
      .el-icon-search {
        font-size: 20px;
        color: #fff;
      }
      div {
        width: 38px;
        height: 38px;
        line-height: 40px;
        background-color: #029aff;
        border-radius: 5px;
      }
    }
    .personal_box {
      position: relative;
      width: 140px;
      height: 100%;
      line-height: 60px;
      text-align: center;
      margin-left: 30px;
      padding-left: 10px;
      box-sizing: border-box;
      .per_top {
        display: flex;
        align-items: center;
        line-height: 60px;
        cursor: pointer;
        color: #fff;
        font-size: 16px;
        img {
          width: 28px;
          height: 28px;
          border-radius: 50%;
          margin-right: 10px;
        }
      }
      .per_body {
        display: none;
        position: absolute;
        bottom: -148px;
        left: 0;
        width: 100%;
        height: 148px;
        text-align: left;
        padding: 12px;
        box-sizing: border-box;
        background-color: #fff;
        line-height: 2;
        font-size: 14px;
        color: #343434;
        border-radius: 0 0 5px 5px;
        transition: all linear 0.5s;
        .per_body_item {
          height: 35px;
          line-height: 35px;
          font-size: 14px;
          cursor: pointer;
          .el-icon-user:before,
          .el-icon-bell:before {
            font-size: 20px;
            margin-right: 5px;
            color: #9a9a9a;
          }
        }
        .goOut {
          width: 60px;
          height: 19px;
          line-height: 19px;
          background: #4490e6;
          border-radius: 10px;
          font-size: 12px;
          color: #fff;
          text-align: center;
          margin: 0 auto;
          margin-top: 20px;
          cursor: pointer;
        }
      }
      .per_body2 {
        display: block;
        transition: all linear 0.5s;
      }
    }
  }
}
.color {
  color: #fff;
  top: 0;
}
</style>
